export const about = [
  <>
    Az indiai fejmasszázs az 5000 éves ájurvéda gyógyítási módszertanon
    alapszik. A legtöbbször a <b>csendet és nyugalmat</b> vonjuk meg magunktól,
    ezáltal állandó stressznek tesszük ki magunkat.
  </>,
];
export const during = [
  <>
    A bowen kezeléssel <b>kombinálva</b> növeli a testi és lelki diszfunkciók
    korrigálását
  </>,
  <>
    <b>Masszázs ágyon</b>, háton fekve szükséges elhelyezkedni - bármilyen
    ruházatban
  </>,
];
export const usefulFor = [
  [
    <>Szellemi frissesség megőrzésére</>,
    <>Hajnövekedés serkentésére</>,
    <>Agyunk vérellátásának javítására</>,
    <>Migrén, fejfájás elmulasztása</>,
  ],
  [
    <>Szemfáradtság</>,
    <>Depresszió, stresszoldás</>,
    <>Álmatlanság, alvászavar</>,
    <>Fáradtság, kimerültség kezelésére</>,
  ],
  [
    <>Egészségmegőrzés céljából</>,
    <>Immunrendszer erősítésére</>,
    <>Görcsös, fájó izomzat megnyugtatására</>,
    <>
      Élénkíti a vérkeringést, eltávolítja a szennyező anyagokat és friss
      oxigént juttat a sejtekbe
    </>,
  ],
];

export const technique = (
  <>
    <b>Időt ad zaklatott elménknek</b> egy kis pihenésre, erőgyűjtésre, és
    képessé tesz bennünket arra, hogy <b>életünket más szemszögből nézzük</b>.
  </>
);
